import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tooltip,
} from "antd";
import { useMemo, useState } from "react";
import {
  ReloadOutlined,
  FilterOutlined,
  EditOutlined,
  SearchOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_MAIN_ASSET_BY_CONTNO,
  POST_MAIN_ASSET_BY_DATE,
  POST_MAIN_ASSET_BY_STATUS,
  POST_REPORT_INVES,
} from "../../API/apiUrls";

import axios from "axios";
import dayjs from "dayjs";
import { ThaiRangePicker } from "../../../hook/ThaiDatePicker";
import ImportInvestigate from "./modal/ImportInvestigate";
import EditRelationAssets from "./modal/EditRelationAssets";
import { ThaiMonthPicker } from "../../../hook/ThaiMonthPicker";
import {
  ONE_MONEY,
  optionsCompanyList,
} from "../../../utils/constant/CompanySelect";
import { ExportPaymentInvestigatePDF } from "./report/ExportPaymentInvestigatePDF";

const Main = () => {
  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateSearch, setDateSearch] = useState([]);
  const [searchInput, setSearchInput] = useState(null);
  const [searchInputTable, setSearchInputTable] = useState(null);
  const [dataRecord, setDataRecord] = useState();
  const [dataUpload, setDataUpload] = useState([]);
  const [isModalImport, setIsModalImport] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [searchSelect, setSearchSelect] = useState(0);
  const [datePickerLoad, setDatePickerLoad] = useState(dayjs());
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [datePickerTable, setDatePickerTable] = useState(null);
  const [arrow, setArrow] = useState("Show");
  const [processStatus, setProcessStatus] = useState(99);
  const toggle = () => setAdvanceSearch((v) => !v);
  const [selectedCompany, setSelectedCompany] = useState({
    value: ONE_MONEY,
  });

  const [reportDataRaw, setReportDataRaw] = useState([]);
  const [reportData, setReportData] = useState([]);

  const { Option } = Select;

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const renderOpteionSearch = () => {
    return (
      <>
        <Option value={1}>
          <span style={{ marginRight: 8 }}>📑</span>
          เลขสัญญา
        </Option>
        <Option value={0}>
          <span style={{ marginRight: 8 }}>🗓️</span>รอบเดือน
        </Option>
        <Option value={2}>
          <span style={{ marginRight: 8 }}>🔄</span>สถานะรอดำเนินการ
        </Option>
      </>
    );
  };

  const renderOpteionStatus = () => {
    return (
      <>
        <Option value={99}>
          <span style={{ marginRight: 8 }}>🗂️</span>ทั้งหมด
        </Option>
        <Option value={0}>
          <span style={{ marginRight: 8 }}>🕓</span>ยังไม่มีข้อมูล
        </Option>
        <Option value={1}>
          <span style={{ marginRight: 8 }}>📨</span>แจ้งขอสืบทรัพย์
        </Option>
        <Option value={2}>
          <span style={{ marginRight: 8 }}>⚙️</span>รอดำเนินการ
        </Option>
        <Option value={3}>
          <span style={{ marginRight: 8 }}>💰</span>เจอทรัพย์
        </Option>
        <Option value={4}>
          <span style={{ marginRight: 8 }}>❌</span>ไม่เจอทรัพย์
        </Option>
      </>
    );
  };

  const handleLoad = () => {
    console.log("searchSelect", searchSelect);
    console.log("searchInput", searchInput);
    console.log("datePickerLoad", dayjs(datePickerLoad).format("YYYY-MM-DD"));
    if (searchSelect !== null && (searchInput || datePickerLoad)) {
      setArrayTable([]);
      handlePreLoad(searchInput);
    } else {
      if (searchSelect === 0 && !datePickerLoad) {
        message.error("กรุณาเลือก ว/ด/ป  !! ");
      } else {
        message.error("กรุณาเลือกกรอกข้อมูลในช่องค้นหา !! ");
      }
    }
  };

  const onChangeInputSearchLoad = (data) => {
    setSearchInput(data);
  };

  const handlePreLoad = (data) => {
    let preDataLoad = {};
    let apiUse;
    console.log(data, datePickerLoad);
    const date1 = dayjs(datePickerLoad).startOf("month").format("YYYY-MM-DD");
    const date2 = dayjs(datePickerLoad).endOf("month").format("YYYY-MM-DD");
    console.log(date1);
    console.log(date2);

    if (searchSelect === 0) {
      preDataLoad = {
        date1: dayjs(datePickerLoad).startOf("month").format("YYYY-MM-DD"),
        date2: dayjs(datePickerLoad).endOf("month").format("YYYY-MM-DD"),
      };
      apiUse = POST_MAIN_ASSET_BY_DATE;
    } else if (searchSelect === 1) {
      preDataLoad = {
        CONTNO: data.trim(),
      };
      apiUse = POST_MAIN_ASSET_BY_CONTNO;
    } else {
      preDataLoad = {
        statusActiveInvestigate: 2,
      };
      apiUse = POST_MAIN_ASSET_BY_STATUS;
    }

    loadData(preDataLoad, apiUse);
  };

  const loadData = async (value, api) => {
    console.log("2.loadData");
    setLoading(true);

    try {
      // ยิง 2 API พร้อมกัน
      const [res1, res2] = await Promise.all([
        axios.post(BASE_URL_BEN + api, value, {
          headers: HEADERS_EXPORT_BEN,
        }),
        axios.post(
          BASE_URL_BEN + POST_REPORT_INVES,
          { date: dayjs(datePickerLoad).format("YYYY-MM-DD") },
          { headers: HEADERS_EXPORT_BEN },
        ),
      ]);

      if (res1.data?.success === "ไม่พบข้อมูล") {
        message.warning("ไม่พบข้อมูลสืบทรัพย์");
        setArrayTable([]);
        setDataArr([]);
      } else {
        let i = 1;
        const newData = res1.data.map((item) => ({ ...item, key: i++ }));
        filterData(newData);
      }
      if (res2.data?.success === "ไม่พบข้อมูล") {
        message.warning("ไม่พบข้อมูลรายงาน");
        setReportData([]);
      } else {
        handleDataReport(res2.data.data);
      }
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
      setArrayTable([]);
      setDataArr([]);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  const customData = (data) => {
    // Group by contno
    const grouped = data.reduce((acc, item) => {
      const key = item.contno;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

    return Object.values(grouped).map((group) => {
      const first = group[0];

      // ✅ นับจำนวน record ที่ contno เดียวกัน
      const reducerCount = group.length;

      const sumAdditionalFee = group.reduce(
        (s, r) => s + Number(r.additionalFee || 0),
        0,
      );
      const sumFamilyReg = group.reduce(
        (s, r) => s + Number(r.familyRegistration || 0),
        0,
      );
      const sumOperationFee = group.reduce(
        (s, r) => s + Number(r.operationFee || 0),
        0,
      );
      const sumSpouseFee = group.reduce(
        (s, r) => s + Number(r.spouseFee || 0),
        0,
      );
      const sumTr14 = group.reduce((s, r) => s + Number(r.tr14 || 0), 0);

      const totalNew =
        sumAdditionalFee +
        sumFamilyReg +
        sumOperationFee +
        sumSpouseFee +
        sumTr14;
      const operationFeeNew = sumOperationFee + sumAdditionalFee;
      const tr14new = sumTr14 + sumFamilyReg;

      return {
        SCHEMA: first.SCHEMA,
        invRoundId: first.invRoundId,
        dateRound: first.dateRound,
        dateSend: first.dateSend,
        invId: first.invId,
        loanId: first.loanId,
        contno: first.contno,
        CUSCOD: first.CUSCOD,
        SNAM: first.SNAM,
        NAME1: first.NAME1,
        NAME2: first.NAME2,
        reducerCount, // ✅ จำนวน record
        additionalFee: String(sumAdditionalFee),
        familyRegistration: String(sumFamilyReg),
        operationFee: String(sumOperationFee),
        spouseFee: String(sumSpouseFee),
        tr14: String(sumTr14),
        totalNew: String(totalNew),
        operationFeeNew: String(operationFeeNew),
        tr14new: String(tr14new),
      };
    });
  };

  const handleDataReport = (data) => {
    if (!data) {
      setReportData(null);
      return;
    }

    const arr = Array.isArray(data) ? data : (data?.data ?? []);

    if (arr.length === 0) {
      setReportData([]);
      return;
    }

    const useData = customData(arr).sort((a, b) =>
      a.contno.localeCompare(b.contno),
    );
    console.log("useData", useData);

    setReportData(useData);
    setReportDataRaw(useData);
  };

  const filterData = (data) => {
    if (data) {
      const useData = sortByRelationFollow(data);
      console.log("5.filterData", useData);
      setArrayTable(useData);
      setDataArr(useData);
      setAdvanceSearch(true);
    } else {
      console.error("data is not an array or is undefined");
      setArrayTable(null);
      setDataArr(null);
      setAdvanceSearch(false);
    }
  };

  function sortByRelationFollow(arr) {
    // 1) แยกเป็นกลุ่มตาม contno (จะได้ไม่ปนข้ามสัญญา)
    const groups = arr.reduce((m, it) => {
      const k = it.contno ?? it.loanId ?? "_";
      (m[k] ??= []).push(it);
      return m;
    }, {});

    const result = [];

    // 2) จัดแต่ละกลุ่ม
    for (const key of Object.keys(groups)) {
      const group = groups[key];

      // followerMap: parentCustomerId -> [followers...]
      const followerMap = new Map();
      for (const it of group) {
        if (it.garno === 0 && it.relationCustomerId != null) {
          const list = followerMap.get(it.relationCustomerId) || [];
          list.push(it); // เก็บตามลำดับเดิม
          followerMap.set(it.relationCustomerId, list);
        }
      }

      // 3) สร้างลำดับใหม่แบบคงความเป็น original order ให้มากที่สุด
      const placed = new Set(); // customerId ที่วางแล้ว

      // ฟังก์ชันช่วย: วางตัวหลัก + ตามด้วยลูก ๆ ที่อ้างถึงเขา
      const placeWithFollowers = (parent) => {
        if (placed.has(parent.customerId)) return;
        result.push(parent);
        placed.add(parent.customerId);

        const followers = followerMap.get(parent.customerId) || [];
        for (const f of followers) {
          if (!placed.has(f.customerId)) {
            result.push(f);
            placed.add(f.customerId);
          }
        }
      };

      // 3.1 วางตัวหลัก (ไม่ใช่ follower ภายในกลุ่ม)
      for (const it of group) {
        const isFollower =
          it.garno === 0 &&
          it.relationCustomerId != null &&
          group.some((x) => x.customerId === it.relationCustomerId); // มีพ่อในกลุ่ม
        if (!isFollower) {
          placeWithFollowers(it);
        }
      }

      // 3.2 วางที่เหลือ (เผื่อกรณี orphan หรือ relation อยู่นอกกลุ่ม)
      for (const it of group) {
        if (!placed.has(it.customerId)) {
          placeWithFollowers(it);
        }
      }
    }

    return result;
  }

  const handleFilterData = () => {
    setLoading(true);
    const rows = Array.isArray(dataArr) ? dataArr : [];
    const norm = (v) =>
      String(v ?? "")
        .trim()
        .toLowerCase();

    const sameDay = (a, b) =>
      !!a &&
      !!b &&
      dayjs(a).format("YYYY-MM-DD") === dayjs(b).format("YYYY-MM-DD");

    const inRange = (dt, [from, to]) => {
      if (!dt || !from || !to) return false;
      const ts = dayjs(dt).valueOf();
      const s = dayjs(from).startOf("day").valueOf();
      const e = dayjs(to).endOf("day").valueOf();
      return ts >= s && ts <= e;
    };

    const q = norm(searchInputTable); // ข้อความค้นหา
    const dateSel = datePickerTable;
    const statusVal = processStatus; // สถานะที่เลือก

    const result = rows.filter((item) => {
      const passQuery =
        !q ||
        [
          item.CUSCOD,
          item.contno, // เพิ่มสำหรับข้อมูลของคุณ
          item.NAME1, // เพิ่มชื่อ
          item.NAME2, // เพิ่มนามสกุล
        ]
          .map(norm)
          .some((val) => val.includes(q));

      // 2) วันที่ (รองรับทั้งวันเดียวและช่วงวันที่)
      let passDate = true;
      if (dateSel) {
        const dateToCheck = item.datetime || item.dateOnlineInvestigate;
        passDate =
          Array.isArray(dateSel) && dateSel.length === 2
            ? inRange(dateToCheck, dateSel)
            : sameDay(dateToCheck, dateSel);
      }

      // 3) สถานะ
      let passStatus = true;
      if (statusVal !== 99 && statusVal != null) {
        // ถ้าเลือกสถานะเฉพาะ (ไม่ใช่ "ทั้งหมด")
        passStatus =
          item.statusActiveInvestigate === statusVal ||
          item.status === statusVal;
      }

      return passQuery && passDate && passStatus;
    });

    console.log("result", result);
    setArrayTable(result);

    // ✅ หา contno จาก result แล้ว filter จาก reportDataRaw
    const selectedContnoSet = new Set(result.map((r) => r.contno));
    const filteredReportData = reportDataRaw.filter((item) =>
      selectedContnoSet.has(item.contno),
    );
    console.log("filteredReportData", filteredReportData);
    setReportData(filteredReportData);

    setTimeout(() => {
      setLoading(false);
    }, 250);

    if (result.length === 0) {
      message.error("ไม่พบข้อมูล");
    } else {
      message.success(`พบข้อมูล ${result.length} รายการ`);
    }
  };

  const reloadData = (status, value) => {
    console.log("value", status, value);
    if (status && value === "success") {
      handleLoad();
    }
  };

  const handleSearchSelect = (value) => {
    setSearchSelect(value);
    setSearchInput(null);
    setDatePickerLoad(dayjs());
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "contno",
      key: "contno",
      align: "center",
      render: (text, record) => <>{record.contno}</>,
    },
    {
      title: "ชื่อ-กสุล",
      dataIndex: "dateSend",
      key: "dateSend",
      align: "center",
      render: (text, record) => (
        <>
          {`${record.SNAM}${record.NAME1} ${record.NAME2 ? record.NAME2 : ""}`}
        </>
      ),
    },
    {
      title: "รอบวันที่ส่งสืบ/รอบที่",
      dataIndex: "dateOnlineInvestigate",
      key: "dateOnlineInvestigate",
      align: "center",
      render: (text, record) => (
        <>
          {dayjs(record.dateOnlineInvestigate)
            .add(543, "year")
            .format("D MMM YY")}{" "}
          <br />
          รอบที่ส่ง {record.roundInvestigate}
        </>
      ),
    },
    {
      title: "สถานะ",
      align: "center",
      render: (record) => (
        <Tag
          color={
            record.statusActiveInvestigate === 3
              ? "green"
              : record.statusActiveInvestigate === 4
                ? "red"
                : record.statusActiveInvestigate === 2
                  ? "blue"
                  : null
          }
        >
          {record.statusActiveInvestigate === 3
            ? "เจอทรัพย์"
            : record.statusActiveInvestigate === 4
              ? "ไม่เจอทรัพย์"
              : record.statusActiveInvestigate === 2
                ? "รอดำเนินการ"
                : record.statusActiveInvestigate === 1
                  ? "แจ้งขอสืบทรัพย์"
                  : record.statusActiveInvestigate === 0
                    ? "ไม่มีข้อมูล"
                    : null}
        </Tag>
      ),
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (record) => (
        <Button
          color="blue"
          variant="outlined"
          onClick={() => {
            console.log(record.data);
            setDataRecord(record.data);
            setIsModalEdit(true);
          }}
        >
          <EditOutlined />
          แก้ไข
        </Button>
      ),
    },
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={"24"} style={{ textAlign: "start" }}>
            <Tooltip
              title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
              arrow={mergedArrow}
            >
              {advanceSearch ? (
                <DownSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle} // antd ส่งค่า checked มาให้
                />
              ) : (
                <UpSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle} // antd ส่งค่า checked มาให้
                />
              )}
            </Tooltip>
            <Space direction="horizontal" size={8}>
              <Select
                size="large"
                style={{ minWidth: "auto", marginRight: 8 }}
                placeholder="เลือกการค้นหา"
                popupMatchSelectWidth={false}
                value={searchSelect}
                onChange={handleSearchSelect}
                showSearch
                optionFilterProp="label"
              >
                {renderOpteionSearch()}
              </Select>
              {searchSelect === 1 ? (
                <Input
                  placeholder="ค้นหาสัญญา"
                  value={searchInput}
                  onChange={(e) => onChangeInputSearchLoad(e.target.value)} // เก็บค่าที่พิมพ์
                  style={{
                    width: "auto",
                    borderRadius: "8px",
                  }}
                  size="small"
                  suffix={
                    searchSelect === 0 ? (
                      <span style={{ marginRight: 5 }}>📑</span>
                    ) : searchSelect === 1 ? (
                      <span style={{ marginRight: 5 }}>👤</span>
                    ) : null
                  }
                />
              ) : searchSelect === 0 ? (
                <ThaiMonthPicker
                  value={datePickerLoad}
                  onChange={setDatePickerLoad}
                  size="large"
                />
              ) : null}
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                  marginLeft: 5,
                }}
                onClick={handleLoad}
                disabled={loading}
              >
                ค้นหา
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => {
                  setSearchInput(null);
                  setSearchInputTable(null);
                  setDatePickerLoad(null);
                }}
                color="red"
                variant="outlined"
              >
                ล้าง
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          {advanceSearch ? (
            <Row>
              <Col
                span={18}
                style={{ textAlign: "start", marginBottom: "10px" }}
              >
                <Space size={10} wrap>
                  <ThaiRangePicker
                    value={datePickerTable}
                    onChange={setDatePickerTable}
                    size="large"
                  />
                  <Input
                    placeholder="ค้นหาสัญญาในตาราง"
                    value={searchInputTable}
                    onChange={(e) => setSearchInputTable(e.target.value)} // เก็บค่าที่พิมพ์
                    style={{
                      width: "auto",
                      borderRadius: "8px",
                    }}
                    size="small"
                    suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                  />
                  <Select
                    size="large"
                    style={{ minWidth: "auto" }}
                    placeholder="สถานะ"
                    popupMatchSelectWidth={false}
                    value={processStatus}
                    onChange={(value) => setProcessStatus(value)}
                    showSearch
                    optionFilterProp="label"
                  >
                    {renderOpteionStatus()}
                  </Select>
                  <Button
                    icon={<FilterOutlined />}
                    size="large"
                    style={{
                      borderRadius: 8,
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      fontWeight: "bold",
                      backgroundColor: "#fff7d6",
                      color: "#333",
                      border: "1px solid #ffe58f",
                    }}
                    onClick={() => handleFilterData()}
                    disabled={dataArr.length === 0}
                  >
                    กรองข้อมูล
                  </Button>
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={() => {
                      setDateSearch(null);
                      setDatePickerTable(null);
                      setSearchInputTable(null);
                      setProcessStatus(99);
                      setArrayTable(dataArr);
                    }}
                    color="red"
                    variant="outlined"
                    disabled={dataArr.length === 0}
                  >
                    ล้าง
                  </Button>
                </Space>
              </Col>
              {searchSelect === 0 && reportData && (
                <Col
                  span={6}
                  style={{ textAlign: "end", marginBottom: "10px" }}
                >
                  <Select
                    options={optionsCompanyList}
                    value={selectedCompany}
                    optionFilterProp="label"
                    popupMatchSelectWidth={false}
                    labelInValue
                    onChange={(option) => setSelectedCompany(option)}
                    style={{ marginRight: "10px" }}
                    size="large"
                  />

                  <Button
                    icon={<PrinterOutlined />}
                    onClick={() =>
                      ExportPaymentInvestigatePDF({
                        reportData,
                        selectedCompany,
                      })
                    }
                    variant="outlined"
                  >
                    พิมพ์
                  </Button>
                </Col>
              )}
            </Row>
          ) : null}

          <Table
            size="small"
            columns={columns}
            dataSource={arrayTable}
            scroll={{ x: 850 }}
            footer={() => (
              <div
                style={{
                  alignItems: "center",
                }}
              >
                <p style={{ margin: 0 }}>
                  จำนวนสัญญาทั้งหมด {arrayTable?.length}
                </p>
              </div>
            )}
          />
        </Spin>
      </Card>
      {isModalImport ? (
        <ImportInvestigate
          open={isModalImport}
          close={setIsModalImport}
          dataDefault={dataUpload}
          func={reloadData}
        />
      ) : null}
      {isModalEdit ? (
        <EditRelationAssets
          open={isModalEdit}
          close={setIsModalEdit}
          data={dataRecord}
          func={reloadData}
        />
      ) : null}
    </>
  );
};

const AssetsMain = MotionHoc(Main);
export default AssetsMain;
